import { Panel } from "@xyflow/react";
import { useEffect, useState } from "react";
import { useAtomValue } from "jotai";
import { hasZslAtom } from "@zapier/canvas-state";

import styles from "./DiagrammingToolbar.module.css";
import { CursorOptions } from "./CursorOptions";
import { BasicNodeOptions } from "./BasicNodeOptions";
import { AppNodeOptions } from "./AppNodeOptions";

export function DiagrammingToolbar() {
  const [showDiagrammingToolbar, setShowDiagrammingToolbar] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowDiagrammingToolbar(true);
    }, 1500);
  }, []);

  const hasZsl = useAtomValue(hasZslAtom);

  return (
    <Panel
      position="bottom-center"
      className={`${styles.toolbar} ${
        showDiagrammingToolbar ? styles.toolbarVisible : ""
      }`}
    >
      <div
        role="toolbar"
        aria-label="Shortcuts toolbar"
        className={styles.appListContainer}
        data-id="appsListContainer"
      >
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Cursor</div>
          <CursorOptions isDisabled={hasZsl} />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Basic</div>
          <BasicNodeOptions isDisabled={hasZsl} />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>Zapier Assets</div>
          <AppNodeOptions isDisabled={hasZsl} />
        </div>
      </div>
    </Panel>
  );
}
